import { getOwaLazyErrorConfig } from 'mini-error-handler/lib/utils/getOwaLazyErrorConfig';
import { LazyModule } from 'owa-bundling-light';
import { withNetworkErrorHandler } from 'mini-error-handler';
import type { RewardsModuleProps } from './components/RewardsModule';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CopilotMail" */ './lazyIndex')
);

export const LazyRewardsModule: React.ComponentType<RewardsModuleProps> = withNetworkErrorHandler(
    null,
    getOwaLazyErrorConfig(lazyModule, m => m.RewardsModule, null)
);
